/**
 * @generated SignedSource<<718b42444c8a677a898f2a8e1dd4f71a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$data = {
  readonly agentWorkspace_siteWfoStatus?: {
    readonly hasProjectEnabledWfo: boolean;
    readonly hasProjectFinishOnboarding: boolean;
  } | null;
  readonly " $fragmentType": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts";
};
export type ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$key = {
  readonly " $data"?: ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipSiteWfoStatus"
    }
  ],
  "kind": "Fragment",
  "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts",
  "selections": [
    {
      "condition": "skipSiteWfoStatus",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "AgentWorkspaceSiteWfoStatus",
          "kind": "LinkedField",
          "name": "agentWorkspace_siteWfoStatus",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasProjectEnabledWfo"
            },
            {
              "kind": "ScalarField",
              "name": "hasProjectFinishOnboarding"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "263bbccb65dcc98490c8ac0a16b05950";

export default node;
